export const SCORED = 'SCORED';
export const UNSCORED = 'UNSCORED';
export const INSTRUCTOR_SCORED = 'INSTRUCTOR_SCORED';
export const INSTRUCTOR_UNSCORED = 'INSTRUCTOR_UNSCORED';
export const INCOMPLETE_ATTEMPT = 'INCOMPLETE_ATTEMPT';
export const NOT_ATTEMPTED = 'NOT_ATTEMPTED';
